import React from "react";
import { Wrapper } from "./styles";
import { LoadingOutlined } from "@ant-design/icons";

export const WizzardButton = ({
	label,
	type,
	disabled,
	onClick,
	loading,
	size,
	typeInput,
}) => {
	return (
		<Wrapper
			size={size}
			onClick={disabled ? null : onClick}
			type={typeInput && typeInput}
			typeForStyled={type}
			disabled={disabled}
		>
			{loading ? <LoadingOutlined style={{ fontSize: 18 }} /> : label}
		</Wrapper>
	);
};
